import React, { Component } from 'react';
import * as moment from 'moment';
import axios from 'axios'
import { Header, Icon, Image, Form, Button } from 'semantic-ui-react'
import { updateToClientRejected, updateToClientApproved } from '../../dashBoard/newDashboard/Utils/StatusUpdateUtils'
import { sendDesignChatActionToSlack } from '../../dashBoard/newDashboard/Utils/StatusUpdateUtils'
import { ref, serverIp, designChatActions } from '../../../config/constants'
import * as UiConsts from '../../../config/UiConstants'

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });



class ImageViewWithActionButtons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rejected: false,
            approved: false,
            rejectedText: '',
            compeleted: false,
            finalApprovalDone: false,
            loading:false,
        }
    }

    componentDidMount() {
        this.sendClientChatOpenToSlack();
    }

    acceptDesign = () => {
        console.log("++++++++:acceptDesign");
        this.setState({
            approved: true,
            complete: true,
        })
    }


    confirmApproval = () => {
        console.log("++++++++++ confirmApproval");
        updateToClientApproved(this.props.message.orderKey, 'normalUser@printboda.com');
        //alert("Thank you for your feedback, we will make the change and send a new design.");

        this.setState({
            finalApprovalDone: true,
            loading:true
        })

        this.resetFeilds();

        // sendDesignChatActionToSlack(this.props.message.firebaseSaveUrl, 'designApproved');
        axios.post(serverIp + 'slackNotifs/sendDesignChatNotif', {
            apiKey: "-LTS8qkgryCp2DScxtJO",
            phonePlusUserFbKey: this.props.message.firebaseSaveUrl,
            designChatAction: designChatActions.designApproved,
            notifKey: this.props.message.notifKey
        })
            .then((response) => {
                console.log("dsc76 responce:" + response.data);

                if (response.data) {
                    console.log("dsc75 sms send reply:" + JSON.stringify(response.data, null, 3));

                    history.push("/design/approved/approved");

                } else {
                    console.log("dsc76 ERROR:");
                    // alert("ERROR:" + JSON.stringify(response.data, null, 3));

                    history.push("/design/approved/approved");
                }

                this.setState({
                    loading:false
                })
            })
            .catch((error) => {
                console.log(error);

                history.push("/design/approved/approved");
            });


    }

    rejectDesign = () => {
        console.log("++++++++:rejectDesign");
        this.setState({
            rejected: true
        })
    }

    sendRejection = () => {
        console.log("++++++++++ sendRejection");
        updateToClientRejected(this.props.message.orderKey, 'normalUser@printboda.com', this.state.rejectedText);
        //alert("Thank you for your feedback, we will make the change and send a new design.");

        this.setState({
            loading:true
        })

        this.resetFeilds();

        // sendDesignChatActionToSlack(this.props.message.firebaseSaveUrl, 'designRejected');

        axios.post(serverIp + 'slackNotifs/sendDesignChatNotif', {
            apiKey: "-LTS8qkgryCp2DScxtJO",
            phonePlusUserFbKey: this.props.message.firebaseSaveUrl,
            designChatAction: 'designRejected',
            notifKey: this.props.message.notifKey
        })
            .then((response) => {
                console.log("dsc76 responce:" + response.data);

                if (response.data) {
                    console.log("dsc75 sms send reply:" + JSON.stringify(response.data, null, 3));

                    history.push("/design/approved/rejected");

                } else {
                    console.log("dsc76 ERROR:");
                    // alert("ERROR:" + JSON.stringify(response.data, null, 3));

                    history.push("/design/approved/rejected");
                }
                this.setState({
                    loading:false
                })
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading:false
                })
                history.push("/design/approved/rejected");
            });


    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }

    resetFeilds = () => {
        console.log("++++++++++ resetFeilds");

        this.setState({
            rejected: false,
            approved: false,
            rejectedText: '',
            complete: true
        })
    }


    addMessageToFirebase = () => {
        console.log("dsc31 ++++++++:addMessageToFirebase");

        let firebaseSaveUrl = this.props.message.firebaseSaveUrl;
        console.log("dsc32 firebaseSaveUrl:" + firebaseSaveUrl);

        var d = new Date();
        //let newTime = -1 * new Date().getTime();
        let newTime = new Date().getTime();

        // let message = {
        //     message: this.state.chatText,
        //     printbodaAdmin: false,
        //     time: newTime,
        //     username: "client",
        // }

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let message = {
            message: this.state.rejectedText,
            printbodaAdmin: false,
            time: newTime,
            username: 'normalUser@printboda.com',
            //imageUrl: this.props.order.designImageUrl,
            adminEmail: 'normalUser@printboda.com',
            dateString: now,
            orderKey: this.props.orderKey.orderKey,
            firebaseSaveUrl: firebaseSaveUrl
        }


        console.log("dsc32 chatmessage:" + JSON.stringify(message, null, 3));

        //GET CHAT MESSAGE FIREBASE KEY
        let newPostKey = ref.child(firebaseSaveUrl).push().key;
        console.log("dsc33 newPostKey:" + newPostKey);

        // amp_logOrderPlaced(orderObject);
        ref.child(firebaseSaveUrl + '/' + newPostKey).set(message);
        //console.log("dsc33 message saved:"+ref.child);

        //clear text
        this.setState({
            chatText: ''
        })
    }

    sendClientChatOpenToSlack = () => {
        console.log("dsc73 slack12 +++++++ sendClientChatOpenToSlack");
        console.log("dsc74 slack13 key:" + this.props.message.orderKey);
        console.log("dsc741 notifKey:" + this.props.message.notifKey);


        axios.post(serverIp + 'slackNotifs/sendDesignChatNotif', {
            apiKey: "-LTS8qkgryCp2DScxtJO",
            phonePlusUserFbKey: this.props.message.firebaseSaveUrl,
            designChatAction: "chatOpened",
            notifKey: this.props.message.notifKey
        })
            .then((response) => {
                console.log(response.data);

                if (response.data) {
                    console.log("dsc75 sms send reply:" + JSON.stringify(response.data, null, 3));

                } else {
                    console.log("dsc76 ERROR:");
                    alert("ERROR:" + JSON.stringify(response.data, null, 3));
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {

        const acceptButton = this.state.approved
            && this.state.compeleted == false
            && this.state.finalApprovalDone == false
            ? ''
            : <div>
                <h4> If the design is ok, please click the button to approve it </h4>
                <Button color='green' onClick={this.acceptDesign}>OK PLEASE PRINT</Button>
            </div>


        const rejectButton = (this.state.rejected || this.state.approved)
            && this.state.compeleted == false
            && this.state.finalApprovalDone == false
            ? ''
            : <div><h4> If the design is NOT ok, please click the button to reject it </h4>
                <Button color='red' onClick={this.rejectDesign}>NOT OK - REJECT</Button></div>


        const goBackButton = this.state.rejected || this.state.acceptDesign
            ? <Button color='blue' onClick={this.resetFeilds}>GO BACK</Button>
            : ''

        const rejectDesignTextBox = this.state.rejected
            ? <div>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='arrow down' circular />
                    <Header.Content>Pls enter your changes below:</Header.Content>
                </Header>
                <Form >
                    <Form.Field>
                        {/* <label>Amount Deposited</label> */}
                        <Form.Input
                            fluid
                            name={'rejectedText'}
                            value={this.state.rejectedText}
                            icon='add user'
                            iconPosition='left'
                            placeholder='PLS LET US KNOW WHAT TO CHANGE ON YOUR DESIGN HERE'
                            // onFocus={props.amp_logFieldClick}
                            onChange={this.handleTextInputChange}
                            type='text'
                        //error={props.formErrorFieldArray['name']}
                        />
                    </Form.Field>
                    <Button color='teal' type='submit' onClick={this.sendRejection}>SEND FEEDBACK</Button>
                </Form>
            </div>
            : ''

        const approveDesignTextBox = this.state.approved
            ? <div>
                <Header as='h2' icon textAlign='center'>
                    <Icon name='arrow down' circular />
                    <Header.Content>Thank you!</Header.Content>
                    <Header.Content>Please confirm the design is ok, by clicking button below </Header.Content>
                    <br />
                    <Button color='teal' type='submit' onClick={this.confirmApproval}>I CONFIRM DESIGN IS OK</Button>

                </Header>

            </div>
            : ''


        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :<div>
            <Image src={this.props.message.imageUrl} size='large' centered />
            <br />
            {acceptButton}
            {approveDesignTextBox}
            <br />
            <br />
            {rejectButton}
            <br />

            {rejectDesignTextBox}

            <br />
            {goBackButton}

        </div>);
    }
}

export default ImageViewWithActionButtons;


// WEBPACK FOOTER //
// ./src/components/newSite/DesignChat/ImageViewWithActionButtons.js